<script>
	/*
		TCareBoolCheckBox.svelte

		This can only have a true or a false value - no other options like "Yes"
	*/

	export let source;
	export let prop;
	export let setValue;
	export let label;

	$: value = source[prop];
	$: isSelected = value === true;				// always checks for true

	const _onClick = () => {
		value = !value;
		setValue(source, prop, value);
	}

</script>


<style>
</style>

<div class="tcui-control flex-row boolean-check-box" on:click={_onClick}>
	{#if isSelected}
		<div class="outer flex-center selected">
			<div class="inner"></div>
		</div>
	{:else}
		<div class="outer flex-center"></div>
	{/if}
	<div class="label">{label}</div>
</div>

